import store from '@/store'

export const checkAcesso = async (to, from, next) => {
  try {
    if (to.meta.requireAuth) {
      let retorno = await store.dispatch('acesso/valida', to.meta.rules || [])
      if (!retorno) return next('/home')
    }
    if (to.meta.root) {
      let retorno = store.getters['auth/root']
      if (!retorno) return next('/home')
    }
    return next()
  } catch (e) {
    await store.dispatch('auth/logout')
  }
}



// WEBPACK FOOTER //
// ./src/router/meta/validaAcesso.js